import ApplicationController from '@app/javascript/controllers/application_controller'

export default class extends ApplicationController {
  static targets = ['locationsFilter', 'legislationStatus', 'legislationType']

  VISIBILITY_RULES = [
    {
      filter: 'pres_doc_types',
      visibleWhen: ({ reg_notice_types }) => {
        return reg_notice_types?.includes('Presidential Document')
      }
    },
    {
      filter: 'stakeholder_chambers',
      visibleWhen: ({ locations }) => {
        if (!locations) {
          return this.usOnlyLocationsAvailable()
        } else {
          return locations.some(l => l.includes('US'))
        }
      }
    },
    {
      filter: 'stakeholder_parties',
      visibleWhen: ({ locations }) => {
        if (!locations) {
          return this.usOnlyLocationsAvailable()
        } else {
          return locations.some(l => l.includes('US'))
        }
      }
    }
  ]

  doConnect() {}

  onFiltersChanged(event) {
    this._toggleFiltersVisibility(event.detail.paramsObj)
  }

  usOnlyLocationsAvailable() {
    return this._locationInputs().every(input => input.value.match(/^US/))
  }

  mapLocationSelected(event) {
    const selectedCode = event.detail.locationCode.toUpperCase()
    const selectedInput = this._locationInputs().find(i => i.value === selectedCode || i.value === 'PS-' + selectedCode)
    const submitButton = this.locationsFilterTarget.querySelector('button.button--primary')
    const clearButton = this.locationsFilterTarget.querySelector('button[id="locationsClearButton"]')
    if (selectedInput) {
      clearButton.click()
      selectedInput.click()
      submitButton.click()
    }
  }

  legislationStatusSelected(event) {
    const selectedStatus = event.detail.key.toUpperCase()
    const selectedInput = this._legislationStatusInputs().find(i => i.value === selectedStatus)
    const clearButton = this.legislationStatusTarget.querySelector('button[id="legislationStatusClearButton"]')
    if (selectedInput) {
      clearButton.click()
      selectedInput.click()
    }
  }

  legislationTypeSelected(event) {
    const selectedType = event.detail.key.toUpperCase()
    const selectedInput = this._legislationTypeInputs().find(i => i.value === selectedType)
    const clearButton = this.legislationTypeTarget.querySelector('button[id="legislationTypeClearButton"]')
    if (selectedInput) {
      clearButton.click()
      selectedInput.click()
    }
  }

  _locationInputs() {
    return Array.from(this.locationsFilterTarget.querySelectorAll('input[name="locations[]"]'))
  }

  _legislationStatusInputs() {
    return Array.from(this.legislationStatusTarget.querySelectorAll('input[name="policy_legislation_status[]"]'))
  }

  _legislationTypeInputs() {
    return Array.from(this.legislationTypeTarget.querySelectorAll('input[name="policy_leg_type[]"]'))
  }

  _toggleFiltersVisibility(searchParams) {
    this.VISIBILITY_RULES.forEach(({ filter, visibleWhen }) => {
      const filterElem = document.querySelector(`[data-filter-name="${filter}"]`)
      if (!filterElem) return

      const isVisible = visibleWhen(searchParams)

      if (isVisible) {
        filterElem.classList.remove('hidden')
      } else {
        filterElem.classList.add('hidden')
        filterElem.controllers.filter.resetStateAndCollapse()
      }
    })
  }
}
